import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { adminApi } from '@/lib/adminApi';
import { groupByDomain } from '@/lib/biomarkers';
import { AdminPage } from '@/admin';

export function DomainDetailPage() {
  const { domain = '' } = useParams();
  const q = useQuery({ queryKey: ['biomarkers'], queryFn: () => adminApi.biomarkers.list() });
  const group = groupByDomain(q.data?.biomarkers ?? []).find((g) => g.domain === domain);
  return (
    <AdminPage title={domain} mono
      backTo={{ to: '/admin/domains', label: 'All domains' }}>
      {q.isLoading ? <p className="text-body-sm text-text-muted">Loading…</p> : null}
      {q.data && !group ? <p className="text-body-sm text-flagged">No domain “{domain}”.</p> : null}
      {group ? (
        <>
          <p className="mb-13 text-body-sm text-text-secondary">{group.biomarkers.length} biomarkers route to the {domain} specialist.</p>
          <div className="flex flex-col gap-2">
            {group.biomarkers.map((b) => (
              <Link key={b.name} to={`/admin/biomarkers/${encodeURIComponent(b.name)}`}
                className="flex items-center justify-between gap-3 rounded border border-border bg-surface px-13 py-2.5 hover:border-accent">
                <span className="font-mono text-[13px]">{b.name}</span>
                <span className="text-[12px] text-text-muted">{b.data_source || ''} ›</span>
              </Link>
            ))}
          </div>
        </>
      ) : null}
    </AdminPage>
  );
}
